<template>
  <ul class="forgeron-menu">
    <template v-for="(link, index) in links" :key="index">
      <li v-if="link.type && link.type === 'title'" class="forgeron-menu-section px-3">{{ link.text }}</li>
      <li v-if="link.type && link.type === 'plain'" class="forgeron-menu-item">
        <a :href="route(link.route, link.params ?? {})" class="forgeron-menu-section px-3">
          <i :class="link.iconClass ?? 'bi bi-trash'" class="h5 my-0"></i>
          {{ link.text }}
        </a>
      </li>
      <li v-if="!link.type" class="forgeron-menu-item">
        <Link v-if="link.route" :href="route(link.route, link.params ?? {})" active-class="active" class="px-3">
          <i :class="link.iconClass ?? 'bi bi-trash'" class="h5 my-0"></i>
          {{ link.text }}
        </Link>
        <Link
          v-else-if="link.resource"
          :href="route(`${routePrefix}.${link.resource}.index`)"
          active-class="active"
          class="px-3"
        >
          <i :class="link.iconClass" class="h5 my-0"></i>
          {{ link.text ?? trans(`models.${link.resource}.name.plural`) }}
        </Link>
        <Link v-else class="text-muted">
          <i :class="link.iconClass ?? 'bi bi-trash'" class="h5 my-0"></i>
          {{ link.text }}
        </Link>
      </li>
    </template>
  </ul>
</template>

<script>
import { Link } from '@inertiajs/vue3';

export default {
  components: {
    Link,
  },
  props: {
    links: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    return {};
  },
};
</script>
